import { render, staticRenderFns } from "./PostTags.vue?vue&type=template&id=6bc3859d&scoped=true"
import script from "./PostTags.vue?vue&type=script&lang=js"
export * from "./PostTags.vue?vue&type=script&lang=js"
import style0 from "./PostTags.vue?vue&type=style&index=0&id=6bc3859d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc3859d",
  null
  
)

export default component.exports